import { Box, Breadcrumbs, Button, Divider, Grid, styled, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material';
import React from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useCommonStyles } from '../../utils';
import StyledTableRow from '../../Component/Common/StyledTableRow';
import StyledTableCell from '../../Component/Common/StyledTableCell';
import { standardDateFormat } from '../../lib/standardDateFormat';
import { BUCKET_URL } from '../../ApiSetUp/AuthApi';
import IconBackground from '../../Component/Common/IconBackground';
import NoDataFound from '../../Component/Common/NoDataFound';
import { data } from 'react-router-dom';

const KeyName = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Light',
}));

const Answer = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Bold',
}));


const ViewPoDocument = ({ setIsViewPoDocument, selectedItem, setSelectedItem, setData, setSearchValue }) => {
    // ============= Hooks =============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    // console.log(selectedItem?.basicDetails?.hazira, "data")

    // console.log(selectedItem?.basicDetails)

    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { setIsViewPoDocument(false); setSelectedItem({}); setData({}); setSearchValue("") }}>
            {"Document List"}
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {selectedItem?.basicDetails?.poNumber ? selectedItem?.basicDetails?.poNumber : "00"}
        </Typography>,
    ];

    return (
        <Grid container padding={"25px"} spacing={2} >
            <Grid item xs={12}>
                <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>{selectedItem?.basicDetails?.poNumber ? selectedItem?.basicDetails?.poNumber : "00"}</Typography>
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                >
                    {breadcrumbs}
                </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={5}>
                <Box sx={{ backgroundColor: theme.palette.bgWhite.main, borderRadius: "30px" }}>
                    <Box sx={{ padding: "25px" }}>
                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}>PO Details</Typography>
                    </Box>
                    <Divider sx={{ borderColor: "#0000001A" }} />
                    <Grid container spacing={3} sx={{ padding: "25px" }}>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>PO Number</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.basicDetails?.poNumber || "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>Vendor Name</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.basicDetails?.vendorName || "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>Category</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.basicDetails?.category || "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>PI Number</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.piDetails?.piNumber || "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>
                                    {selectedItem?.port
                                        ? selectedItem.port
                                        : selectedItem?.basicDetails?.hazira !== null
                                            ? "Hajira Port"
                                            : "Port"}
                                </KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.basicDetails?.hazira ? standardDateFormat(selectedItem?.basicDetails?.hazira) : "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>BL Number</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.blDetails?.blNumber || "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>Shiping Line</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.basicDetails?.shippingLine || "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>Document Set</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.documentSetDetails?.documentSet || "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>BOE Date</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.boeDetails?.boeDate ? standardDateFormat(selectedItem?.boeDetails?.boeDate) : "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>BOE Number</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.boeDetails?.boeNumber || "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>Payment Status</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.basicDetails?.paymentStatus || "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>Advanced License</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.basicDetails?.advanceLicenseNumber || "NA"}</Answer>
                            </Grid>

                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={4}>
                                <KeyName>Invoice Number</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={7}>
                                <Answer>{selectedItem?.invoiceDetails?.invoiceNumber || "NA"}</Answer>
                            </Grid>

                        </Grid>
                        <Grid container item xs={12} display={"flex"} gap={2}>
                            <Button className={classes?.cancelButton} onClick={() => { setIsViewPoDocument(false); setSelectedItem({}); setData({}) }}>Cancel</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            <Grid item xs={12} md={7}>
                <Box sx={{ backgroundColor: theme.palette.bgWhite.main, padding: "25px", borderRadius: "30px" }}>
                    <Box>
                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}>Uploaded Documents</Typography>
                    </Box>
                    <CommonTableData title={"1. PI"} subTitle={`(${selectedItem?.piDetails?.piDocument?.length})`} documents={selectedItem?.piDetails?.piDocument} />
                    <CommonTableData title={"2. BL"} subTitle={`(${selectedItem?.blDetails?.blDocument?.length})`} documents={selectedItem?.blDetails?.blDocument} />
                    <CommonTableData title={"3. Document Send"} subTitle={`(${selectedItem?.documentSetDetails?.documentSetDocument?.length})`} documents={selectedItem?.documentSetDetails?.documentSetDocument} />
                    <CommonTableData title={"4. BOE Document"} subTitle={`(${selectedItem?.boeDetails?.boeDocument?.length})`} documents={selectedItem?.boeDetails?.boeDocument} />
                    <CommonTableData title={"5. Swify Copy"} subTitle={`(${selectedItem?.swiftCopyDetails?.swiftCopyDocument?.length})`} documents={selectedItem?.swiftCopyDetails?.swiftCopyDocument} />
                    <CommonTableData title={"6. Debit Advice"} subTitle={`(${selectedItem?.debitAdviceDetails?.debitAdviceDocument?.length})`} documents={selectedItem?.debitAdviceDetails?.debitAdviceDocument} />
                    <CommonTableData title={"7. Eway"} subTitle={`(${selectedItem?.ewayDetails?.ewayDocument?.length})`} documents={selectedItem?.ewayDetails?.ewayDocument} />
                    <CommonTableData title={"8. Invoice"} subTitle={`(${selectedItem?.invoiceDetails?.invoiceDocument?.length})`} documents={selectedItem?.invoiceDetails?.invoiceDocument} />
                    <CommonTableData title={"9. Packing List"} subTitle={`(${selectedItem?.packingListDetails?.packingListDocument?.length})`} documents={selectedItem?.packingListDetails?.packingListDocument} />
                    <CommonTableData title={"10. PIMS"} subTitle={`(${selectedItem?.pimsDetails?.pimsDocument?.length})`} documents={selectedItem?.pimsDetails?.pimsDocument} />
                </Box>
            </Grid>

        </Grid>
    )
}

export default ViewPoDocument

const CommonTableData = ({ title, subTitle, documents }) => {
    // ================= Hooks =================
    const theme = useTheme();
    const tabelHeader = ["document", "DATE", "Size", "Action"]

    return (
        <>
            <Box display={"flex"} alignItems={"center"} gap={0.5} mb={1} mt={2}>
                <Typography fontFamily={"Satoshi-Bold"} fontSize={"18px"}>{title}</Typography>
                <Typography fontFamily={"Satoshi-Light"} color={"#00000066"} fontSize={"18px"}>{subTitle}</Typography>
            </Box>
            <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                {tabelHeader?.map((ele) => {
                                    return (
                                        <StyledTableCell>{ele}</StyledTableCell>
                                    )
                                })}
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {documents?.length > 0 ?
                                documents?.map((row, index) => (
                                    <React.Fragment key={index}>
                                        <StyledTableRow>
                                            <StyledTableCell sx={{ borderBottomLeftRadius: index === documents.length - 1 ? "26px" : 0, }}
                                            > {row?.image?.split("/").pop()}</StyledTableCell>
                                            <StyledTableCell> {row.date ? standardDateFormat(row.date) : "NA"}</StyledTableCell>
                                            <StyledTableCell >
                                                <Box sx={{ display: "flex", justifyContent: "start", alignItems: "center", gap: "10px" }}>
                                                    {row.size ? row.size.toFixed(2) + " MB" : ""}
                                                    {row?.status && <Typography color={"#4F880A"} fontFamily={"Satoshi-Bold"} fontSize={"14px"}>{row?.status}</Typography>}
                                                </Box>
                                            </StyledTableCell>
                                            <StyledTableCell sx={{ borderBottomRightRadius: index === documents.length - 1 ? "26px" : "0px" }}>
                                                <IconBackground icon={"visibility"} disabled={row.status === 1} onClick={() => window?.open(`${BUCKET_URL + row?.image}`)} />
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    </React.Fragment>
                                ))
                                :
                                <StyledTableRow>
                                    <StyledTableCell colSpan={12}>
                                        <NoDataFound />
                                    </StyledTableCell>
                                </StyledTableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </>
    )
}